var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",staticStyle:{"background-color":"#DBDBDB"}},[_c('h4',{staticClass:"alert-heading border border-dark border-top-0 border-left-0 border-right-0"},[_vm._v(" Gold Marketplace Password ")]),_c('p',[_vm._v(" Gold Marketplace Module requires password, please contact your Account Manager for further details. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }